import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Helmet } from "react-helmet";

export default class PageNotFound extends React.Component {
  render() {
    return (
      <Container>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Page not found - Southern News</title>
        </Helmet>
        <Row className="pt-8">
          <Col md={8} lg={5} className="m-auto">
            <h1 className="text-display-1 text-danger">Page Not Found</h1>
          </Col>
        </Row>
      </Container>
    );
  }
}
